"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskViewTableReducer = exports.defaultTaskViewTableState = void 0;
const actions_1 = require("./actions");
const constants_1 = require("../../shared/table-config/constants");
const reducers_1 = require("../../shared/table-config/reducers");
const attributes_1 = require("../../../constants/attributes");
exports.defaultTaskViewTableState = Object.assign(Object.assign({}, reducers_1.defaultTableState), { isSidebarOpen: false, selectedTreeNodePath: '', 
    // Default sorting by product SKU/ID
    sort: {
        key: attributes_1.CustomProductAttributes.ExternalId,
        direction: 0 /* SortDirection.Ascending */,
        default: true,
    } });
const taskViewTableReducer = (
// eslint-disable-next-line default-param-last
state = exports.defaultTaskViewTableState, action) => {
    var _a, _b;
    if (action.type === actions_1.RESET_TASK_VIEW_TABLE) {
        // Reset only the persisted table settings (filter/search/sort/pageSize/columns).
        // Preserve task-scoped state that is derived from the URL/task context, not from table
        // settings: `selectedTreeNodePath` (used to resolve the tree node and mount the products
        // table) and `isSidebarOpen`. Wiping the path here would unmount the table and cancel the
        // in-flight products request whenever the view state is reset.
        return Object.assign(Object.assign({}, exports.defaultTaskViewTableState), { selectedTreeNodePath: state.selectedTreeNodePath, isSidebarOpen: state.isSidebarOpen });
    }
    if (action.type === actions_1.TASK_VIEW_SIDEBAR_TOGGLE) {
        return Object.assign(Object.assign({}, state), { isSidebarOpen: (_a = action.payload.changes) !== null && _a !== void 0 ? _a : !state.isSidebarOpen });
    }
    if (action.type === actions_1.TASK_VIEW_SELECTED_TREE_NODE_PATH) {
        return Object.assign(Object.assign({}, state), { selectedTreeNodePath: (_b = action.payload.changes) !== null && _b !== void 0 ? _b : state.selectedTreeNodePath });
    }
    // Handle generic table actions (including page size)
    if (action.type.includes(constants_1.TableEntityPrefix.HLQATaskView)) {
        return (0, reducers_1.createTableReducer)(constants_1.TableEntityPrefix.HLQATaskView, exports.defaultTaskViewTableState)(state, action);
    }
    return state;
};
exports.taskViewTableReducer = taskViewTableReducer;
